import { useRouter } from 'next/router';
import styled, { css, DefaultTheme, FlattenInterpolation, ThemeProps } from 'styled-components';

import CompanyLogo from '~components/CompanyLogo';
import { getFontStyle } from '~components/Text/helper';
import { CompanyBase } from '~types/company';
import { millionFormattedtoString } from '~utils/formatted/number';
import { getShortenedAddress } from '~utils/locationFormat';

interface Props extends Omit<CompanyBase, 'name' | 'logo' | 'niceId' | 'id'> {
  companyId: number;
  companyName: string;
  href: string;
  salary?: number;
  inlineCss?: FlattenInterpolation<ThemeProps<DefaultTheme>>;
  onClick?: () => void;
}
export default function CompanyLogoCard({
  companyName,
  location,
  locationCode,
  salary,
  href,
  inlineCss,
  PK_NM_HASH,
  onClick,
  ...props
}: Props) {
  const router = useRouter();

  const handleClick = () => {
    if (onClick) {
      onClick();
    }

    router.push(href);
  };

  return (
    <Anchor inlineCss={inlineCss} onClick={handleClick} {...props}>
      <LeftArea>
        <CompanyLogo PK_NM_HASH={PK_NM_HASH} logoCss={logoCss} />
        <CompanyInfo>
          <Title>{companyName}</Title>
          <Location>{getShortenedAddress(locationCode, location)}</Location>
        </CompanyInfo>
      </LeftArea>
      {!!salary && <Salary>평균 {millionFormattedtoString(salary)}만원</Salary>}
    </Anchor>
  );
}

const Anchor = styled.a<Pick<Props, 'inlineCss'>>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border-radius: 4px;
  overflow-x: auto;
  max-width: 100%;
  box-sizing: border-box;

  ${({ inlineCss }) => inlineCss};
`;

const LeftArea = styled.div`
  display: flex;
  width: 100%;
  overflow: hidden;
`;

const logoCss = css`
  width: 45px;
  height: 45px;
  min-width: 45px;
  padding: 3px;

  & > img {
    width: 24px;
    height: 15px;
  }
`;
const Title = styled.div`
  ${getFontStyle('bold120_B3')};
  max-width: 100%;
  margin-bottom: 3px;
  color: ${({ theme }) => theme.colors.gray900};
  text-align: left;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

const Location = styled.div`
  ${getFontStyle('midium120_C1')};
  color: ${({ theme }) => theme.colors.gray700};
  text-align: left;
`;

const CompanyInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 12px;
  overflow: hidden;

  ${({ theme }) => theme.media.mobile} {
    flex: inherit;
  }
`;

const Salary = styled.div`
  ${getFontStyle('midium150_C1')};
  text-align: right;
  color: ${({ theme }) => theme.colors.gray800};
  white-space: nowrap;
`;
